import { createSlice } from "@reduxjs/toolkit";
import axios from "../app/axios";

export const applicationSlice = createSlice({
  name: "applicationSlice",
  initialState: {
    applicationData: {},
    applicationDataEdit: {},
    applicationTest: {},
    requestData: {},
    interviewSlot: [],
    documents: [],
    paymentResponse: {},
    applicantFee: {},
    applicantStatus: {},
    optionList: {},
    fileList: {},
    inquiry: {},
    preferredContactList: {},
    sendInfoList: {},
    academicInterestList: {},
    preferredGenderCode: {},
    fullPartTimeList: {},
    certificationprogram: {},
    errorMessage: undefined,
    dataFetchingStatus: false,
    errorStatusCode: undefined,
    notifyEvents: undefined,
    applicationcertificationprogram: [],
    applicationCheckList: {},
  },

  reducers: {
    setapplicationData: (state, action) => {
      state.applicationData = action.payload;
    },
    setInquiry: (state, action) => {
      state.inquiry = action.payload;
    },
    setPaymentResponse: (state, action) => {
      state.paymentResponse = action.payload;
    },
    setApplicantFee: (state, action) => {
      state.applicantFee = action.payload;
    },
    setApplicantStatus: (state, action) => {
      state.applicantStatus = action.payload;
    },
    setOptionList: (state, action) => {
      state.optionList = action.payload;
    },
    setFileTypesList: (state, action) => {
      state.fileList = action.payload;
    },
    setpreferredContactList: (state, action) => {
      state.preferredContactList = action.payload;
    },
    setfullPartTimeList: (state, action) => {
      state.fullPartTimeList = action.payload;
    },
    setacademicInterestList: (state, action) => {
      state.academicInterestList = action.payload;
    },
    setsendInfoList: (state, action) => {
      state.sendInfoList = action.payload;
    },
    setpreferredGenderCode: (state, action) => {
      state.preferredGenderCode = action.payload;
    },
    setApplicationTestData: (state, action) => {
      state.applicationTest = action.payload;
    },
    setInterviewSlot: (state, action) => {
      state.interviewSlot = action.payload;
    },
    setDocuments: (state, action) => {
      state.documents = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setErrorStatusCode: (state, action) => {
      state.errorStatusCode = action.payload;
    },
    setDataFetchingStatus: (state, action) => {
      state.dataFetchingStatus = action.payload;
    },
    removeElementsFromArray: (state, action) => {
      state.applicationData = action.payload;
    },
    removeApplicationTestData: (state, action) => {
      state.applicationTest = action.payload;
    },
    removeInterviewSlot: (state, action) => {
      state.interviewSlot = action.payload;
    },
    removeExistingStatus: (state, action) => {
      state.applicantStatus = action.payload;
    },
    setapplicationDataEditData: (state, action) => {
      state.applicationDataEdit = action.payload;
    },
    setNotifyEvents: (state, action) => {
      state.notifyEvents = action.payload;
    },
    setRequestData: (state, action) => {
      state.requestData = action.payload;
    },
    setcertificationprogram: (state, action) => {
      state.certificationprogram = action.payload;
    },
    setApplicationCertificationProgram: (state, action) => {
      state.applicationcertificationprogram = action.payload;
    },
    setApplicantCheckList: (state, action) => {
      state.applicationCheckList = action.payload;
    },
  },
});

export const {
  setapplicationData,
  setApplicationTestData,
  setErrorMessage,
  setDataFetchingStatus,
  removeElementsFromArray,
  setapplicationDataEditData,
  setErrorStatusCode,
  removeApplicationTestData,
  setInterviewSlot,
  setDocuments,
  removeInterviewSlot,
  setPaymentResponse,
  setApplicantFee,
  setNotifyEvents,
  setApplicantStatus,
  setInquiry,
  removeExistingStatus,
  setRequestData,
  setOptionList,
  setFileTypesList,
  setpreferredContactList,
  setacademicInterestList,
  setsendInfoList,
  setfullPartTimeList,
  setpreferredGenderCode,
  setcertificationprogram,
  setApplicationCertificationProgram,
  setApplicantCheckList,
} = applicationSlice.actions;

export const getApplicationData = (userId) => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));

  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`application/getContacts/${userId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setapplicationData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const getApplicantStatus = (userId) => (dispatch) => {
  dispatch(removeExistingStatus({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`application/getApplicantStatus/${userId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setApplicantStatus(response.data));
    })
    .catch((error) => {
      // dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getOptionList = (entity, attributename) => (dispatch) => {
  dispatch(removeExistingStatus({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`optionSets/${entity}/${attributename}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setOptionList(response.data));
    })
    .catch((error) => {
      // dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response?.data?.error || error.message || 'An error occurred'));
      dispatch(setErrorStatusCode(error.response?.status || 500));
    });
};

export const getfileTypesList = (entity, attributename) => (dispatch) => {
  dispatch(removeExistingStatus({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`optionSets/${entity}/${attributename}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setFileTypesList(response.data));
    })
    .catch((error) => {
      // dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getapplicationDetails = () => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios
    .get("applicationDetails")
    .then((response) => {
      dispatch(setcertificationprogram(response?.data?.certificationprogram));
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getApplicantCheckList = (certificationprogramid) => (dispatch) => {
  dispatch(removeExistingStatus({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`application/${certificationprogramid}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setApplicantCheckList(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getApplicationsByAppicantId = (applicantId) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios
    .get(`applicationDetails/${applicantId}`)
    .then((response) => {
      dispatch(
        setApplicationCertificationProgram(
          response?.data?.certificationprogram,
        ),
      );
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getSendInfo = (entity, attributename) => (dispatch) => {
  dispatch(removeExistingStatus({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`optionSets/${entity}/${attributename}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setsendInfoList(response.data));
    })
    .catch((error) => {
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const getpreferredContactList =
  (entity, attributename) => (dispatch) => {
    dispatch(removeExistingStatus({}));
    dispatch(setDataFetchingStatus(true));
    dispatch(setErrorMessage(undefined));
    dispatch(setErrorStatusCode(undefined));
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + window.localStorage.getItem("x-auth-token");
    axios
      .get(`optionSets/${entity}/${attributename}`)
      .then((response) => {
        dispatch(setDataFetchingStatus(false));
        dispatch(setpreferredContactList(response.data));
      })
      .catch((error) => {
        // dispatch(setDataFetchingStatus(false));
        dispatch(setErrorMessage(error.response.data.error));
        dispatch(setErrorStatusCode(error.response.status));
      });
  };
export const getFullPartTime = (entity, attributename) => (dispatch) => {
  dispatch(removeExistingStatus({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`optionSets/${entity}/${attributename}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setfullPartTimeList(response.data));
    })
    .catch((error) => {
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getAcademicInterest = (entity, attributename) => (dispatch) => {
  dispatch(removeExistingStatus({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`optionSets/${entity}/${attributename}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setacademicInterestList(response.data));
    })
    .catch((error) => {
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getpreferredGenderCode = (entity, attributename) => (dispatch) => {
  dispatch(removeExistingStatus({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`optionSets/${entity}/${attributename}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setpreferredGenderCode(response.data));
    })
    .catch((error) => {
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getApplicationTestData = (userId) => (dispatch) => {
  dispatch(removeApplicationTestData({}));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`application/applicationTest/${userId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setApplicationTestData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const SaveInquiry = (data) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios
    .post("inquiry", data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setRequestData(response.data));
      dispatch(setErrorMessage(response.data.message));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const getInquiryData = () => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios
    .get("inquiry")
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setInquiry(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const SaveApplicationTestData = (data) => (dispatch) => {
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post("application/applicationTest/", data)
    .then((response) => {
      dispatch(setErrorMessage(response.data.message));
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const SaveApplicationTestOnlineData = (data) => (dispatch) => {
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post("application/applicationTestOnline/", data)
    .then((response) => {
      dispatch(setErrorMessage(response.data.message));
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const postApplicationData = (data) => (dispatch) => {
  dispatch(removeElementsFromArray({}));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post("application/setContacts", data)
    .then((response) => {
      dispatch(setErrorMessage(response.data.message));
      dispatch(setErrorStatusCode(response.data.responseCode));
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const clearApplicationData = () => (dispatch) => {
  dispatch(removeElementsFromArray({}));
};

export const updateApplicationEditData = (data) => (dispatch) => {
  dispatch(setapplicationDataEditData(data));
};
export const clearErrorStatusCode = () => (dispatch) => {
  dispatch(setErrorStatusCode(undefined));
};
export const clearErrorMessage = () => (dispatch) => {
  dispatch(setErrorMessage(undefined));
};
export const clearApplicantStatus = () => (dispatch) => {
  dispatch(removeExistingStatus({}));
};

export const saveFileUploadData = (formData) => (dispatch) => {
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post("/application/fileUpload/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      dispatch(setErrorMessage(response.data.message));
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getInterviewSlotAvliable = (userId) => (dispatch) => {
  dispatch(removeInterviewSlot([]));
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`application/interviewSlotAvailable/`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setInterviewSlot(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getDocuments = (userId) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`documents`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setDocuments(response.data.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const saveInterviewSlot = (body) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post(`application/interviewSlotAvailable/`, body)
    .then((response) => {
      dispatch(setErrorMessage(response.data.message));
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const PaymentRequest = (body) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post(`students/select-class/payment-request`, body)
    .then((response) => {
      dispatch(setPaymentResponse(response.data));
      dispatch(setErrorMessage(response.data.message));
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const VapulsPaymentRequest = (body) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post(`/application/payment-request/vapulus`, body)
    .then((response) => {
      dispatch(setPaymentResponse(response.data));
      dispatch(setErrorMessage(response.data.message));
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getApplicantFee = (userId) => (dispatch) => {
  // dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post(`application/getApplicationFeeDetails/`, userId)
    .then((response) => {
      // dispatch(setDataFetchingStatus(false));
      dispatch(setApplicantFee(response.data));
    })
    .catch((error) => {
      // dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const updateApplicantPaymentDetails = (userId) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`application/getApplicationFeeDetails/${userId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(response.data.message));
    })
    .catch((error) => {
      // dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export default applicationSlice.reducer;
